import SupervisorAllocationGetter from "segments/SupervisorAllocationGetter/SupervisorAllocationGetter";
import { useFocusRange } from "utils/customHooks/genericHooks";
import { useProcessIdsForDataDumpFullRange } from "./useProcessIdsForDataDumpFullRange";

export function SupervisorAllocationGetterConnected() {
  const focusRange = useFocusRange();

  const processIdsForDataDumpFullRange = useProcessIdsForDataDumpFullRange();
  return (
    <SupervisorAllocationGetter
      timeRange={focusRange}
      processIds={processIdsForDataDumpFullRange}
    />
  );
}
